<div class="row">
  <div class="col-6">
    <app-multi-select-with-static-options
      class="flex-grow-1"
      [formControl]="yearControl"
      [selectOptions]="yearSelectOptions"
      [multi]="false"
      [label]="'authenticated.time_tracking.overview.index.views.year' | translate"
    ></app-multi-select-with-static-options>
  </div>

  <div class="col-6">
    @if (monthControl) {
      <app-multi-select-with-static-options
        class="flex-grow-1"
        [formControl]="monthControl"
        [selectOptions]="monthSelectOptions"
        [multi]="false"
        [label]="'authenticated.time_tracking.overview.index.views.month' | translate"
      ></app-multi-select-with-static-options>
    }
  </div>
</div>
